import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Eye, Handshake } from 'lucide-react';

const ICONS = [ShieldCheck, Lock, Eye, Handshake];

const About = ({ t }) => {
  return (
    <section id="about" className="relative py-20 sm:py-24 lg:py-28" data-testid="about">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <div className="kicker-mono mb-3">{t.about.kicker}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-[650] tracking-tight text-white" data-testid="about-title">
            {t.about.title}
          </h2>
          <p className="mt-5 text-white/75 text-base leading-relaxed">{t.about.p1}</p>
          <p className="mt-3 text-white/70 text-base leading-relaxed">{t.about.p2}</p>
          <p className="mt-3 text-white/60 text-sm italic leading-relaxed border-l-2 border-[rgb(var(--brand-electric))] pl-4">{t.about.p3}</p>

          <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-[rgba(5,126,243,.12)] border border-[rgba(5,126,243,.35)] px-4 py-2">
            <span className="h-2 w-2 rounded-full bg-[rgb(var(--brand-electric))] shadow-[0_0_10px_rgba(5,126,243,.8)]" />
            <span className="font-mono-accent text-xs uppercase tracking-wider text-white">{t.about.badge}</span>
          </div>

          <div className="mt-8 grid grid-cols-3 gap-3">
            {[
              { k: '2016', l: 'Since' },
              { k: 'NDA', l: 'Ready' },
              { k: '24/7', l: 'Support' },
            ].map((m) => (
              <div key={m.k} className="rounded-xl border border-white/10 bg-[rgb(var(--bg-2))] p-4">
                <div className="font-display text-2xl font-[700] text-white">{m.k}</div>
                <div className="mt-1 kicker-mono text-white/60">{m.l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="kicker-mono mb-3">{t.about.values_title}</div>
          <div className="grid sm:grid-cols-2 gap-4">
            {t.about.values.map((v, i) => {
              const Icon = ICONS[i] || ShieldCheck;
              return (
                <motion.div
                  key={v.name}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: i * 0.06 }}
                  whileHover={{ y: -3 }}
                  className="rounded-2xl border border-white/10 bg-[rgb(var(--bg-2))] p-5 hover:border-[rgba(5,126,243,.5)] transition-colors"
                  data-testid={`value-card-${i}`}
                >
                  <div className="h-10 w-10 rounded-lg bg-[rgba(5,126,243,.12)] border border-[rgba(5,126,243,.35)] flex items-center justify-center text-[rgb(var(--brand-electric))]">
                    <Icon size={20} />
                  </div>
                  <div className="mt-4 font-display text-lg font-[650] text-white">{v.name}</div>
                  <div className="mt-1.5 text-sm text-white/65 leading-relaxed">{v.desc}</div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
